import React__default from 'react';
import { makeStyles, Box, Container, Grid, Typography, Link } from '@material-ui/core';
import ArrowRightIcon from '../../widgets/streamline-icon/ArrowRightIcon.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    title: {
      minHeight: theme.spacing(7.5),
      margin: theme.spacing(3, 0)
    },
    description: {
      minHeight: theme.spacing(8),
      marginBottom: theme.spacing(5)
    },
    cardIcon: {
      width: theme.spacing(15),
      height: theme.spacing(15)
    },
    cursor: {
      "&:hover": {
        cursor: "pointer"
      }
    }
  };
});
var ColumnCards = function ColumnCards(_ref) {
  var bgColor = _ref.bgColor,
    gridColumns = _ref.gridColumns,
    gridSpacing = _ref.gridSpacing,
    items = _ref.items,
    onLinkClick = _ref.onLinkClick;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    position: "relative",
    py: 3,
    px: isExtraSmallScreen() ? 1 : 0
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Grid, {
    spacing: gridSpacing,
    container: true
  }, items && items.map(function (i) {
    var _i$links;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      container: true,
      key: i === null || i === void 0 ? void 0 : i.id,
      xs: 12,
      sm: 6,
      md: gridColumns ? 12 / gridColumns : 12
    }, /*#__PURE__*/React__default.createElement(Box, {
      p: 3,
      bgcolor: "#F4F4ED",
      display: "flex",
      flexDirection: "column"
    }, (i === null || i === void 0 ? void 0 : i.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(i.imageUrl, {
        width: 120,
        height: 120
      }),
      className: classes.cardIcon,
      alt: (i === null || i === void 0 ? void 0 : i.imageTitle) || ""
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h4",
      component: "h3",
      className: classes.title
    }, i === null || i === void 0 ? void 0 : i.title), (i === null || i === void 0 ? void 0 : i.description) && /*#__PURE__*/React__default.createElement(Box, {
      className: classes.description
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: i.description
    })), /*#__PURE__*/React__default.createElement(Box, {
      mt: "auto"
    }, (i === null || i === void 0 ? void 0 : i.links) && (i === null || i === void 0 || (_i$links = i.links) === null || _i$links === void 0 ? void 0 : _i$links.map(function (l, index) {
      return /*#__PURE__*/React__default.createElement(Link, {
        key: l === null || l === void 0 ? void 0 : l.label,
        href: l === null || l === void 0 ? void 0 : l.url,
        color: "initial",
        underline: "none",
        variant: "body1",
        className: classes.cursor,
        onClick: function onClick() {
          return onLinkClick(l === null || l === void 0 ? void 0 : l.id);
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1,
        borderTop: index === 0 ? 1 : 0,
        borderBottom: 1
      }, l === null || l === void 0 ? void 0 : l.label, /*#__PURE__*/React__default.createElement(ArrowRightIcon, null)));
    })))));
  }))));
};
ColumnCards.propTypes = {
  bgColor: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  onLinkClick: PropTypes__default.func,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string,
    description: PropTypes__default.string,
    imageUrl: PropTypes__default.string,
    links: PropTypes__default.arrayOf(PropTypes__default.shape({
      label: PropTypes__default.string,
      url: PropTypes__default.string
    }))
  }))
};

export { ColumnCards as default };
//# sourceMappingURL=ColumnCards.js.map
